import { render, staticRenderFns } from "./commissions.vue?vue&type=template&id=6ca9ffb8&scoped=true&"
import script from "./commissions.vue?vue&type=script&lang=ts&"
export * from "./commissions.vue?vue&type=script&lang=ts&"
import style0 from "./commissions.vue?vue&type=style&index=0&id=6ca9ffb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca9ffb8",
  null
  
)

export default component.exports